var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"autocomplete-wrapper"},[_c('GmapAutocomplete',{ref:"autocomplete",staticClass:"form-control form-icon icon-location",attrs:{"selectFirstOnEnter":true,"options":_vm.options,"value":_vm.getPlaceName()},on:{"place_changed":_vm.setPlace}}),_c('div',{staticClass:"clear",on:{"click":function($event){return _vm.clear()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }